var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7013 4.30364C11.5181 4.49057 11.4155 4.74189 11.4155 5.00364C11.4155 5.26539 11.5181 5.51671 11.7013 5.70364L13.3013 7.30364C13.4882 7.48687 13.7396 7.5895 14.0013 7.5895C14.2631 7.5895 14.5144 7.48687 14.7013 7.30364L18.4713 3.53364C18.9742 4.64483 19.1264 5.88288 18.9078 7.08279C18.6892 8.2827 18.11 9.38749 17.2476 10.2499C16.3852 11.1124 15.2804 11.6915 14.0805 11.9101C12.8806 12.1287 11.6425 11.9765 10.5313 11.4736L3.62132 18.3836C3.2235 18.7815 2.68393 19.005 2.12132 19.005C1.55871 19.005 1.01914 18.7815 0.62132 18.3836C0.223496 17.9858 0 17.4462 0 16.8836C0 16.321 0.223496 15.7815 0.62132 15.3836L7.53132 8.47364C7.02848 7.36245 6.87624 6.12441 7.09486 4.9245C7.31349 3.72459 7.89261 2.6198 8.75504 1.75736C9.61748 0.894929 10.7223 0.315811 11.9222 0.0971842C13.1221 -0.121442 14.3601 0.0308066 15.4713 0.533642L11.7113 4.29364L11.7013 4.30364Z",
    fill: "url(#paint0_radial_1418_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1418_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.51757 -19.005 18.0337 4.6202 6.7437 19.005)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564246,
    stopColor: "#96C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8ECF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.c7a1201e39d7a2063738521af682abdd.svg";
export { ForwardRef as ReactComponent };